import type { IShippingState } from "@/api/QuoteCustomizeClientPC"
import type { IClippedCouponItem } from '@/api/QuoteCustomizeClientPC';

type OrderData = {
  isQuote: boolean,
  imprintSysNo: number,
  priceSysNo: number,
  methodName: string,
  transitTime: number,
  couponClipList: IClippedCouponItem[],
  productionTime: number,
  states: IShippingState[],
  isHasVipProduct: boolean,
  orderType: number,
  buyQty: Record<string, number>;
  couponCode: string,
  isAdmin?: boolean
  // 布尔值，表示是否只能选择一个尺寸
  isSingleSizeSelection: boolean
}

export const useOrder = (): OrderData => {
  const orderData = (window as any).orderData

  const { isQuote, orderType,
    couponCode, transitTime,
    imprintSysNo,
    priceSysNo,
    buyQty,
    productionTime,
    states,
    couponClipList,
    isHasVipProduct,
    methodName,
    isAdmin,
    isSingleSizeSelection
  } = orderData

  return {
    isQuote,
    imprintSysNo,
    priceSysNo,
    methodName,
    transitTime,
    buyQty,
    couponClipList,
    productionTime,
    states,
    isHasVipProduct,
    orderType,
    couponCode,
    isAdmin,
    isSingleSizeSelection
  }
}
